export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Anggota',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Anggota',
      url: 'members',
      icon: 'fa fa-address-card-o'
    },
    {
      title: true,
      name: 'Berita',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Berita',
      url: '/news',
      icon: 'fa fa-edit'
    },
    {
      title: true,
      name: 'Pendanaan',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Pendanaan',
      url: '/funding',
      icon: 'fa fa-handshake-o'
    },
    {
      name: 'Daftar Pembayaran',
      url: '/payment',
      icon: 'fa fa-money'
    },
    {
      title: true,
      name: 'Adik Asuh',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Adik Asuh',
      url: '/student',
      icon: 'fa fa-child'
    },
    {
      divider: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js